import { helpers } from '../services/helpers';
import FooterNavigation from './FooterNavigation';
import React, { useState, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import ScoreIcon from './ScoreIcon'
import EditDeleteFooter from './EditDeleteFooter';
import DeleteModal from './DeleteModal';
import { api } from '../services/api';

function PainTimelineCard({
    diary,
    currentIndex,
    leftClick,
    rightClick,
    getColorMapping,
    closeCard,
    cardVisible,
    isPain,
    toast,
    loadDiary,
    canEdit
}) {
    // TODO: SWIPE LOGIC IS DUPLICATED
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const minSwipeDistance = 50;

    const [showDelete, setShowDelete] = useState(false);
    const [deleteAnswer, setDeleteAnswer] = useState('');
    const [deleting, setDeleting] = useState(false);

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            rightClick();
        } else if (isRightSwipe) {
            leftClick();
        }
    };

    const entry = diary?.entries?.[currentIndex.current];

    const colorMap = useMemo(() => {
        return getColorMapping(diary.attributes);
    }, [diary, currentIndex.current, getColorMapping]);

    const chartOption = useMemo(() => {
        if (!entry) return {};

        return {
            xAxis: {
                type: 'category',
                data: entry.attributes.map(attr => attr.name),
                axisLabel: { rotate: 30 }
            },
            yAxis: {
                type: 'value',
                min: 0,
                max: 10,
            },
            series: [
                {
                    type: 'bar',
                    data: entry.attributes.map(attr => ({
                        value: attr.value,
                        itemStyle: { color: colorMap.get(attr.name) }
                    })),
                    barWidth: '60%'
                }
            ],
            tooltip: {
                trigger: 'axis',
                formatter: (params) => {
                    const p = params[0];
                    return `${p.name}: ${p.value}`;
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                top: '5%',
                containLabel: true
            }
        };
    }, [entry, colorMap]);

    const closeDelete = () => {
        setShowDelete(false)
    }
    const openDelete = () => {
        setDeleting(false);
        setDeleteAnswer("")
        setShowDelete(true)
    }

    const deleteEntry = (e) => {
        e.preventDefault()
        setDeleting(true)
        const entry = diary?.entries?.[currentIndex.current];
        api.deleteDiaryEntry(entry.id)
            .then(res => {
                toast("Succesfully Deleted")
                closeDelete();
                loadDiary()
            }).finally(() => {
                setDeleting(false);
            })
    }



    if (!cardVisible) {
        return (
            <div></div>
        )
    }
    return (
        <div style={{ padding: "0px 0.5rem" }}>
            <DeleteModal
                deleteAnswer={deleteAnswer}
                setDeleteAnswer={setDeleteAnswer}
                deleteAsset={deleteEntry}
                showDelete={showDelete}
                deleting={deleting}
                closeDelete={closeDelete}
                assetType="Diary Entry"
            />
            {entry ? (
                <div
                    className="update-card"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    style={{ padding: "0", paddingBottom: "0.5rem" }}
                >
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div className="update-header" style={{ marginBottom: "0", paddingLeft: "12px" }}>
                                <span className="post-op-timestamp">
                                    {helpers.diaryTime(entry.createdAt)}
                                </span>
                            </div>
                            <button className="cancel-button" onClick={closeCard}>
                                ×
                            </button>
                        </div>
                        <div style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                            {isPain ? (
                                <div style={{ marginBottom: '1rem' }}>
                                    <ReactECharts
                                        option={chartOption}
                                        style={{ height: '200px', width: '100%' }}
                                        notMerge={true}
                                        lazyUpdate={true}
                                    />
                                </div>
                            ) : (
                                <div className="form-content pain-entry" style={{ padding: "0.5rem 0" }}>
                                    <div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexDirection: "column",
                                                        width: "6rem",
                                                        height: "6rem",
                                                        borderRadius: "50%",
                                                        color: "white",
                                                        fontSize: "1.5rem",
                                                        fontWeight: "bold",
                                                        boxShadow: "0 10px 15px rgba(0,0,0,0.1)",
                                                        transition: "all 0.3s ease",
                                                        backgroundColor: helpers.getColorForScore(entry.activityLevel)
                                                    }}
                                                >
                                                    <div style={{
                                                        fontSize: "2rem",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                        <ScoreIcon score={entry.activityLevel} getIconForScore={helpers.getActivityIconForScore}/>
                                                    </div>
                                                    <div> {entry.activityLevel}</div>
                                                </div>
                                                <div style={{ marginTop: "0.75rem" }}>
                                                    <span
                                                        style={{
                                                            fontSize: "1.125rem",
                                                            fontWeight: 500,
                                                            transition: "color 0.3s ease",
                                                            color: helpers.getColorForScore(entry.activityLevel)
                                                        }}
                                                    >
                                                        {helpers.getDescriptionForScore(entry.activityLevel)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <p className="update-text" style={{ textAlign: "center" }}>{entry.notes}</p>

                            <FooterNavigation
                                assetType="entry"
                                leftClick={leftClick}
                                rightClick={rightClick}
                                currentIndex={currentIndex.current}
                                length={diary.entries.length}
                            />
                        </div>

                        {canEdit && (
                            <EditDeleteFooter
                                to={`/diary/entry/${diary.entries[currentIndex.current].id}`}
                                openDelete={openDelete}
                            />
                        )}
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    );
}

export default PainTimelineCard;
